import useOpenApiClient from '@/hooks/useOpenApiClient';
import { cn, ColoredTileIndex, coloredTileVariants } from '@/lib/utils';
import { components } from '@/types/api';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export function BenefitIcon(props: {
  lineItemBenefit: components['schemas']['ReceiptLineItemBenefit'];
  index: number;
  hideBeneFitName?: boolean;
}) {
  const { apiFetch } = useOpenApiClient();
  const accountsQuery = useQuery({
    queryKey: ['v1', 'accounts'],
    queryFn: () => apiFetch.GET('/accounts'),
    select: (data) => data.data?.data,
  });

  const { lineItemBenefit, index, hideBeneFitName } = props;
  const benefitNotEligibleOrNotApplied = !lineItemBenefit.applied || !lineItemBenefit.eligible;

  const accountIndex = useMemo(() => {
    const idx = accountsQuery.data?.findIndex(
      (account) => account.id === lineItemBenefit.account_id,
    );
    return idx && idx !== -1 ? idx : index;
  }, [accountsQuery.data, lineItemBenefit.account_id, index]);

  return (
    <div className="flex items-center gap-1 text-xs leading-normal font-normal">
      <div
        className={cn(
          coloredTileVariants({ index: (accountIndex % 12) as ColoredTileIndex }),
          'relative flex h-4 w-4 items-center justify-center rounded-full text-xs leading-3 font-normal',
          {
            'border-primary-dark border': benefitNotEligibleOrNotApplied,
          },
        )}
      >
        <span className="opacity-80">{lineItemBenefit.account_name[0]}</span>
        {benefitNotEligibleOrNotApplied && (
          <hr className="border-primary-dark absolute w-full rotate-[-30deg] border-x-[0.5]" />
        )}
      </div>
      {hideBeneFitName ? null : <span>{lineItemBenefit.account_name}</span>}
    </div>
  );
}
